"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAdAnalyticsPlacementTypes = void 0;
const AdAnalyticsPlacementTypes_1 = require("../../entity/AdAnalyticsPlacementTypes");
const AdAnalyticsVideo_1 = require("../../entity/AdAnalyticsVideo");
const adAnalyticsMedia_1 = require("./adAnalyticsMedia");
const createAdAnalyticsPlacementTypes = () => AdAnalyticsVideo_1.AdAnalyticsPlacementTypes.fromJSON({
    platforms: [
        AdAnalyticsPlacementTypes_1.AdAnalyticsPlatform.fromJSON({
            key: 'facebook',
            name: 'hoge',
            networks: [adAnalyticsMedia_1.createAdAnalyticsMedia()],
        }),
    ],
    periods: ['lifetime'],
});
exports.createAdAnalyticsPlacementTypes = createAdAnalyticsPlacementTypes;
